<ng-container *ngIf="isParentRoute; then parentRoute; else childRoute">
</ng-container>


<ng-template #childRoute>
    <router-outlet></router-outlet>
</ng-template>


<ng-template #parentRoute>
    <!-- START: Header (market, equipment group, price alert) -->
    <div class="md-top">
        <div class="md-card md-header">
            <div class="md-header__banner">
                <span class="fw-bolder">{{user?.firstName}},</span>
                {{'WELCOME_TO_YOUR_ENERGY_MARKET' | translate}}
            </div>

            <div class="md-header__controls">
                <!-- Market -->
                <div class="md-header__field">
                    <div class="md-header__label">{{ 'MARKET' | translate }}</div>
                    <div class="mv-segmented md-header__market">
                        <button type="button" class="mv-segmented__item" [class.active]="marketDealersForm.controls.marketType.value == 'Electricity'" (click)="marketDealersForm.controls.marketType.setValue('Electricity')">
                            <i class="fas fa-bolt me-2"></i>{{ 'ELECTRICITY' | translate }}
                        </button>
                        <button type="button" class="mv-segmented__item" disabled [class.active]="marketDealersForm.controls.marketType.value == 'NaturalGas'">
                            <i class="fas fa-fire me-2"></i>{{ 'NATURAL_GAS' | translate }}
                        </button>
                    </div>
                </div>

                <div class="md-header__selects">
                    <!-- Opportunity (create a proposal) or contract (edit) -->
                    <div class="md-header__field md-header__field--grow">
                        <div class="md-header__label">{{ 'EQUIPMENT_GROUPS' | translate }}</div>
                        <div class="d-flex gap-2">
                            <div class="flex-grow-1 min-w-0">
                                <is-multi-select #equipmentGroupMultiSelect [externalLoading]="equipmentGroupLoading" [prependIcon]="true" [options]="selectionOptions" [singleSelectOnly]="true" [emitChangeOnClose]="false" [formControl]="marketDealersForm.controls.selection" [singleSelectOnly]="true" [selectableParents]="false"></is-multi-select>
                            </div>

                            <button type="button" class="btn btn-icon btn-primary md-header__icon-btn" *ngIf="isNullOrUndefinedOrWhitespace(marketDealersForm.controls.opportunityId.value!)" (click)="openNewOpportunityCreationDialog()">
                                <i class="far fa-plus"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-light-primary md-header__icon-btn" *ngIf="!isNullOrUndefinedOrWhitespace(marketDealersForm.controls.opportunityId.value!)" (click)="openNewOpportunityEditDialog(marketDealersForm.controls.opportunityId.value!)">
                                <i class="far fa-pencil"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Equipments -->
                    <div class="md-header__field md-header__field--grow" *ngIf="hasSelection">
                        <div class="md-header__label">{{ 'EQUIPMENTS' | translate }}</div>
                        <is-multi-select #equipmentsMultiSelect [externalLoading]="equipmentsLoading" [prependIcon]="true" [options]="equipmentMultiSelectOptions" [singleSelectOnly]="false" [onlyOneParentSelectionAllowed]="true" [emitChangeOnClose]="false" [formControl]="filtersForm.controls.equipments" [parentItemsAsMainSelection]="false"></is-multi-select>
                    </div>
                </div>
            </div>
        </div>

        <!-- Price alert -->
        <div class="md-card md-alert">
            <div class="md-alert__title">
                <span class="md-alert__icon"><i class="far fa-bell"></i></span>
                {{ 'PRICE_ALERT' | translate }}
            </div>
            <div class="md-alert__description">{{ 'PRICE_ALERT_DESCRIPTION' | translate }}</div>

            <div class="md-chips">
                <button type="button" class="md-chip md-chip--up" *ngFor="let percentage of [20, 15, 10, 5]" [class.active]="selectedPrice == percentage" (click)="togglePriceAlert(percentage); selectedPercentage = percentage; canChoosePercentage = false; customPercentage = 0">
                    +{{ percentage }}%
                </button>

                <button type="button" class="md-chip md-chip--custom" [class.active]="customPercentage != 0" cdkOverlayOrigin #customPercentageTrigger="cdkOverlayOrigin" (click)="canChoosePercentage = !canChoosePercentage">
                    <ng-container *ngIf="customPercentage != 0; else alarmPlusIcon">{{ marketDealersForm.controls.percentage.value }}%</ng-container>
                    <ng-template #alarmPlusIcon><i class="fas fa-alarm-plus"></i></ng-template>
                </button>

                <button type="button" class="md-chip md-chip--down" *ngFor="let percentage of [-5, -10, -15, -20]" [class.active]="selectedPrice == percentage" (click)="togglePriceAlert(percentage); selectedPercentage = percentage; canChoosePercentage = false; customPercentage = 0">
                    {{ percentage }}%
                </button>
            </div>

            <!-- Custom percentage popover -->
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="customPercentageTrigger" [cdkConnectedOverlayOpen]="canChoosePercentage" [cdkConnectedOverlayPositions]="customPercentageOverlayPositions" [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="opacity-0" (backdropClick)="canChoosePercentage = false" (detach)="canChoosePercentage = false">
                <div class="md-popover">
                    <div class="md-popover__label">{{ 'PRICE_ALERT' | translate }} (%)</div>
                    <div class="md-custom-alert">
                        <input type="number" step="any" class="form-control form-control-sm text-center" [formControl]="marketDealersForm.controls.percentage" min="-100" max="100" (keydown.enter)="!(isCustomPercentageDuplicate() || marketDealersForm.get('percentage')?.invalid) && onCustomPercentageConfirm()">
                        <button class="btn btn-success btn-sm btn-icon" type="button" [disabled]="isCustomPercentageDuplicate() || marketDealersForm.get('percentage')?.invalid" (click)="onCustomPercentageConfirm()">
                            <i class="fa fa-check"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <!-- END: Header -->

    <!-- START: SPOT and HEDGING Markets -->
    <ng-container [ngTemplateOutlet]="isSpot ? spotMarket : hedgingMarket"></ng-container>
    <!-- END: SPOT and HEDGING Markets -->

</ng-template>

<ng-template #spotMarket>
    <div class="col-12">
        <div class="row">
            <!-- PRICE 1 -->
            <div class="col-6" *ngFor="let price of pricesForHtml">
                <div class="border border-solid blur border-active-primary price rounded p-5 px-8 bg-white mt-5">
                    <!-- START: Title -->
                    <div class="row mb-5">
                        <div class="col-12 fw-bold text-primary fs-1">
                            {{ 'PRICE' | translate }} {{ price.priceName }}
                        </div>
                    </div>
                    <!-- END: Title -->
                    <!-- START: Price -->
                    <div class="row">
                        <div class="col-10">
                            <div class="row gx-0">
                                <div class="col-4">
                                    <div class="border border-solid p-3 lh-1 bg-secondary rounded rounded-end-0">
                                        <div>{{ 'FROM' | translate }} </div>
                                        <div>
                                            <span class="fw-800 fs-2qx"> 35 </span>
                                            <span class="fs-4"> €/MWh </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-8 border border-solid py-2 px-3 rounded rounded-start-0 align-content-center">
                                    <div class="row fs-7 gy-1">
                                        <div class="col-6" *ngIf="+price.standardPrice > 0">
                                            <div class="d-flex justify-content-between">
                                                <span class=""> {{ 'STANDARD' | translate }}</span>
                                                <span class="fw-bold"> {{price.standardPrice}} €/MWh </span>
                                            </div>
                                        </div>
                                        <div class="col-6" *ngIf="+price.offPeakPrice > 0">
                                            <div class="d-flex justify-content-between">
                                                <span class=""> {{ 'OFF_PEAK' | translate }}</span>
                                                <span class="fw-bold"> {{price.offPeakPrice}} €/MWh </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row fs-7 gy-1">
                                        <div class="col-6" *ngIf="+price.peakPrice > 0">
                                            <div class="d-flex justify-content-between">
                                                <span class=""> {{ 'PEAK' | translate }}</span>
                                                <span class="fw-bold"> {{price.peakPrice}} €/MWh </span>
                                            </div>
                                        </div>
                                        <div class="col-6" *ngIf="+price.superOffPeakPrice > 0">
                                            <div class="d-flex justify-content-between">
                                                <span class=""> {{ 'SUPER_OFF_PEAK_ABBREVIATED' | translate }}</span>
                                                <span class="fw-bold"> {{price.superOffPeakPrice}} €/MWh </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 fs-2 fw-bold btn border border-solid btn-light-success border-success-subtle rounded d-flex align-items-center justify-content-center">
                            {{ 'SIMULATE' | translate }}
                        </div>
                    </div>
                    <!-- END: Price -->
                    <!-- START: Details -->
                    <div class="row gy-3 my-5">
                        <div class="col-5">
                            <div> {{'PERIOD' | translate }}</div>
                            <div class="fw-bolder"> {{ price.datePeriod }} </div>
                        </div>
                        <div class="col-5">
                            <div> {{'PRICE_VALIDITY' | translate }}</div>
                            <div class="fw-bolder"> {{'HIRE_UNTIL' | translate}} {{ price.priceExpiryDate | date: 'shortDate' }} </div>
                        </div>
                        <div class="col-5">
                            <div> {{'CONTRACTED_MWH_LIMIT' | translate }}</div>
                            <div class="fw-bolder"> {{ price.mwhLimit }} MWh </div>
                        </div>
                        <div class="col-5">
                            <div> {{'SUPPLIER' | translate }}</div>
                            <div class="fw-bolder"> {{ price.supplier }} </div>
                        </div>
                        <div class="col-12">
                            <div> {{'CONSUMPTION_INTEREST' | translate }}</div>
                            <div class="w-100 rounded bg-secondary mt-1">
                                <div class="w-75 h-100 rounded rounded-end-0 bg-light-warning text-warning py-1 ps-2">
                                    <span>
                                        <i class="fal fa-circle-info"></i>
                                    </span>
                                    <span> {{ 'ONLY_X_REMAINING_AVAILABLE_MWH' | translate: { x: price.mwhLimit - price.interestedConsumption } }}</span>
                                </div>
                            </div>
                            <div class="w-100 position-relative">
                                <span style="position:absolute; left: calc(75% - 5.5ch)" class="fw-bold fs-7 text-gray-600">{{price.interestedConsumption}} MWh</span>
                                <span style="position:relative; left: calc(100% - 5.5ch)" class="fw-bold fs-7 text-gray-400">{{price.mwhLimit}} MWh</span>
                            </div>
                        </div>
                    </div>
                    <!-- END: Details -->
                    <!-- START: Button -->
                    <div class="row mt-10">
                        <div class="col-12">
                            <span>
                                <i class="fas fa-circle-info"></i>
                            </span>
                            <span>
                                {{ 'ECONOMIC_CONDITIONS' | translate }}
                            </span>
                        </div>
                    </div>
                    <!-- END: Button -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <a [routerLink]="'/market-dealers/hedging'">
                                <div class="btn btn-primary rounded w-100 text-center fw-bolder fs-5">
                                    {{ 'I_AM_INTERESTED' | translate }}
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- START: Highlighted Price -->
    <!-- END: Highlighted Price -->
</ng-template>

<ng-template #hedgingMarket>
    <app-hedging-view
        [selectedGrouping]="selectedGroupingId!"
        [selectedOpportunity]="opportunity"
        [opportunityId]="marketDealersForm.controls.opportunityId.value!"
        [contractId]="marketDealersForm.controls.contractId.value"
        [selectedContract]="selectedContract"
        [selectedMarket]="marketDealersForm.controls.marketType.value!"
        [currentEquipments]="selectedEquipments"
        [electricityPriceUpdates$]="electricityPricesUpdate$"
    />
</ng-template>